import styled from 'styled-components';
import { Button, ButtonProps } from '@fluentui/react-components';
import { colorPallet } from '../theme/colors';

export const PrimaryButton = styled(Button)<ButtonProps>`
  color: ${(props) => props.theme.primaryButtonColor};
  background-color: ${(props) => props.theme.primaryButtonBackground};

  &:hover {
    color: ${(props) => props.theme.primaryButtonColor};
    background-color: ${(props) => props.theme.primaryButtonBackgroundHover};
  }

  &:active {
    color: ${(props) => props.theme.primaryButtonColor} !important;
    background-color: ${(props) =>
      props.theme.primaryButtonBackgroundActive} !important;
  }

  &.full-width {
    width: 100%;
  }
`;

export const TimeOffButton = styled(Button)<ButtonProps>`
  color: ${(props) => props.theme.primaryButtonColor};
  background-color: ${(props) => props.theme.primaryButtonBackground};
  width: 50%;
  gap: 0.25rem;
  @media (max-width: 1000px) {
    width: 100%;
  }

  &:hover {
    color: ${(props) => props.theme.primaryButtonColor};
    background-color: ${(props) => props.theme.primaryButtonBackgroundHover};
  }

  &:disabled {
    background: ${colorPallet.lightGray};
    color: ${(props) => props.theme.primaryButtonColorDisabled} !important;
    filter: grayscale(1);
  }

  &:active {
    color: ${(props) => props.theme.primaryButtonColor} !important;
    background-color: ${(props) =>
      props.theme.primaryButtonBackgroundActive} !important;
  }
`;

export const PrimaryButtonLight = styled(Button)<ButtonProps>`
  color: ${(props) => props.theme.primaryButtonV2Color};
  background: ${(props) => props.theme.primaryButtonV2Background};

  &:hover {
    color: ${(props) => props.theme.primaryButtonV2ColorHover};
    background: ${(props) => props.theme.primaryButtonV2BackgroundHover};
  }

  &:active {
    color: ${(props) => props.theme.primaryButtonV2ColorActive} !important;
    background: ${(props) =>
      props.theme.primaryButtonV2BackgroundActive} !important;
  }
`;

export const SecondaryButton = styled(Button)<ButtonProps>`
  color: ${(props) => props.theme.defaultButtonColor};
  background-color: ${(props) => props.theme.defaultButtonBackground};
  border: 1px solid ${(props) => props.theme.defaultButtonBorderColor};

  &:hover {
    color: ${(props) => props.theme.defaultButtonColor};
    background-color: ${(props) =>
      props.theme.defaultButtonHoverBackground} !important;
    border: 1px solid ${(props) => props.theme.defaultButtonBorderColor} !important;
  }

  &:active {
    color: ${(props) => props.theme.defaultButtonColor} !important;
    background-color: ${(props) =>
      props.theme.defaultButtonActiveBackground} !important;
    border: 1px solid ${(props) => props.theme.defaultButtonBorderColor} !important;
  }
`;
